<template>  	
    <div>
		<p id="result-current-weight" v-if="checkIfNullOrEmpty(answers.currentWeight.kg)">
			<strong>Current Weight</strong><br>
			<span>{{answers.currentWeight.kg}}kg ({{answers.currentWeight.st}}st, {{answers.currentWeight.lb}}lb)</span>
		</p>
		
		<p id="result-previous-weight" v-if="checkIfNullOrEmpty(answers.previousWeight.kg)">
			<strong>Heaviest available weight 3-6 months ago</strong><br>
			<span>{{answers.previousWeight.kg}}kg ({{answers.previousWeight.st}}st, {{answers.previousWeight.lb}}lb)</span>
		</p>

		<p id="result-adjust-current-weight" v-if="answers.currentWeight.kg != result.adjustedCurrentWeight.kg && answers.currentWeight.kg != null">
			<strong>Adjusted Current Weight</strong><br>
			<span>
				<span v-if="hasDecimal(result.adjustedCurrentWeight.kg) == true">
					{{result.adjustedCurrentWeight.kg.toFixed(2)}}kg 
				</span>				
				<span v-if="hasDecimal(result.adjustedCurrentWeight.kg) == false">
					{{result.adjustedCurrentWeight.kg.toFixed(0)}}kg 
				</span>
				({{result.adjustedCurrentWeight.st}}st, {{result.adjustedCurrentWeight.lb}}lb)
			</span>
		</p>

		<p id="result-adjust-previous-weight" v-if="answers.previousWeight.kg != result.adjustedPreviousWeight.kg && answers.previousWeight.kg != null">
			<strong>Adjusted Heaviest available weight 3-6 months ago</strong><br>
			<span>
				<span v-if="hasDecimal(result.adjustedPreviousWeight.kg) == true">
					{{result.adjustedPreviousWeight.kg.toFixed(2)}}kg 
				</span>				
				<span v-if="hasDecimal(result.adjustedPreviousWeight.kg) == false">
					{{result.adjustedPreviousWeight.kg.toFixed(0)}}kg 
				</span>
				({{result.adjustedPreviousWeight.st}}st, {{result.adjustedPreviousWeight.lb}}lb)
			</span>
		</p>		
		
		<p id="result-have-oedema" v-if="checkIfNullOrEmpty(answers.haveOedema.text)">
			<strong>{{questions[0].title}}</strong><br>
			<span>{{answers.haveOedema.text}}</span>
		</p>
		<p id="result-is-oedema" v-if="answers.haveOedema.text == 'Yes' && checkIfNullOrEmpty(answers.isOedema.text)">
			<strong>{{additionalQuestions[0].title}}</strong><br>
			<span>{{answers.isOedema.text}}</span>
		</p>
		<p id="result-oedema-present" v-if="answers.haveOedema.text == 'Yes' && checkIfNullOrEmpty(answers.oedemaPresent.text)">
			<strong>{{additionalQuestions[1].title}}</strong><br>
			<span>{{answers.oedemaPresent.text}}</span>
		</p>
		
		<p id="result-is-amputations" v-if="checkIfNullOrEmpty(answers.isAmputations.text)">
			<strong>{{questions[1].title}}</strong><br>
			<span>{{answers.isAmputations.text}}</span>
		</p>

		<ul id="result-list-amputations" v-if="answers.isAmputations.text == 'Yes'">
			<!-- <span v-if="answers.isAmputations.value = 0">N/A</span> -->
			<li v-for="part in answers.amputations.parts.filter(i => i.answer.value != 0)" :key="part">
				{{part.title}} - {{part.answer.text}}
			</li>
			<!-- <li v-if="checkIfNullOrEmpty(answers.amputations.parts[i])">
				no values selected
			</li>
			<li v-for="part in answers.amputations.parts.filter(i => i.answer.value == 0)" :key="part">
				N/A
			</li> -->
		</ul>
		
		<p id="result-weight-loss" v-if="checkIfNullOrEmpty(answers.weightLossPlanned.text)">
			<strong>Was the weight loss planned or unplanned?</strong><br>
			<span>{{answers.weightLossPlanned.text}}</span>
		</p>

		<p id="result-current-height" v-if="checkIfNullOrEmpty(answers.currentHeight.cm)">
			<strong>Current Height</strong><br>
			<span>{{answers.currentHeight.cm}}cm ({{answers.currentHeight.ft}}ft, {{answers.currentHeight.inches}}in)</span>
		</p>
		
		<p id="result-date-height" v-if="answers.dateCurrentMeasured.value != null && answers.dateCurrentMeasured.value != ''">
			<strong>Date current height measured</strong><br>
			<span>{{answers.dateCurrentMeasured.value}}</span>
		</p>
		<p id="result-ade" v-if="checkIfNullOrEmpty(answers.acuteDiseaseEffect.value)">
			<strong>Acute Disease Effect (ADE)</strong><br>
			<span>{{answers.acuteDiseaseEffect.text}}</span>
		</p>
    </div>
</template>

<script>

import questions from "@/components/data/questions.json";
import additional from "@/components/data/additional.json";

export default {
	name: "Answers",
    props: {
        answers: Object,
		result: Object, 
    },
	data() {
		return {
			questions: questions,
			additionalQuestions: additional
		}
	},
	methods: {
		checkAmpultations() {
			return this.answers.isAmputations.value != (null || 1);
		},
		
		checkIfNullOrEmpty(checkValue) {
			return checkValue > 0 || checkValue != null;
		},
		
		hasDecimal (num) {
			return !!(num % 1);
		}
	}
};
</script>
